import Component from "@base/js/component";
import MultiSelect from "@components/multi-select/multi-select";

export default class Search extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".search";

  static children = {
    heroForm: ".search-results-hero__form",
    multiselects: [".multi-select"],
  };

  eventHandlers = {
    heroForm: {
      submit: this.onQuerySubmit,
    },
  };

  // Should store multiselect instances, keyed by filterName
  multiselects = {};

  // Will be called upon component instantiation
  afterInit() {
    Promise.all(
      this.children.multiselects.map((multiselect) =>
        MultiSelect.getInstanceByElement(multiselect)
      )
    ).then((_multiselects) => {
      _multiselects.forEach((multiselect) => {
        this.multiselects[multiselect.filterName] = multiselect;
      });
    });
  }

  onQuerySubmit(e) {
    e.preventDefault();
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
Search.init();
